import { MatButtonModule, MatIconModule, MatInputModule } from '@angular/material';

import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './pages/footer/footer.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SpellCheckModule } from 'src/app/directives/spell-check/spell-check.module';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    MatInputModule,
    AgmCoreModule.forRoot({
      libraries: ['places'],
      language: 'en',
      apiKey: environment.MAP_API_KEY
    }),
    MatIconModule,
    RouterModule,
    MatButtonModule,
    MatFormFieldModule,
    SpellCheckModule,
  ],
  exports: [
    FooterComponent,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    SpellCheckModule
  ]
})
export class SharedModule { }
